// src/redux/shop/shop.data.js
const SHOP_DATA = [
  {
    id: 1,
    title: "Men Wigs",
    routeName: "men-wigs",
    items: [
      {
        id: 1,
        name: "Non Surgical Hair Replacement Aplus",
        imageUrl: "https://i.ibb.co/BKTB2R05/men1.jpg",
        price: 29999,
        description: "Premium quality human hair wig for men. Natural look, comfortable fit."
      },
      {
        id: 2,
        name: "Men's Lace best Hair - Dark Brown",
        imageUrl: "https://i.ibb.co/BVbmSvW2/men2.jpg",
        price: 34999,
        description: "Swiss lace front men's wig with natural hairline. 100% human hair."
      },
      {
        id: 3,
        name: "Men's Monofilament Wig - Jet Black",
        imageUrl: "https://i.ibb.co/prfFqQWq/men3.jpg",
        price: 29999,
        description: "Monofilament top allows multi-directional parting. Lightweight."
      },
      {
        id: 4,
        name: "Men's Full Lace Wig - Medium Brown",
        imageUrl: "https://i.ibb.co/7xVhRD7s/men4.jpg",
        price: 29999,
        description: "Full lace construction for natural look. Can be styled any direction."
      },
      {
        id: 5,
        name: "Men's Skin Top Wig - Ash Brown",
        imageUrl: "https://i.ibb.co/jZyrM40D/men5.jpg",
        price: 29999,
        description: "Advanced skin top technology for natural scalp appearance."
      },
      {
        id: 6,
        name: "Men's Military Style Wig - Dark Ash",
        imageUrl: "https://i.ibb.co/spTczmTt/men6.jpg",
        price: 27999,
        description: "Short military style wig with natural texture. Easy to maintain."
      },
      {
        id: 7,
        name: "Men's Custom Fit Wig - Salt & Pepper",
        imageUrl: "https://i.ibb.co/7Jp1brN2/men7.jpg",
        price: 29999,
        description: "Custom fit wig with salt & pepper color. Natural aging appearance."
      },
      {
        id: 8,
        name: "Men's Premium Human Hair Wig - Black",
        imageUrl: "https://i.ibb.co/BKTB2R05/men1.jpg",
        price: 29999,
        description: "Premium quality human hair wig with natural shine and texture."
      },
      {
        id: 9,
        name: "Men's Swiss Lace Wig - Brown",
        imageUrl: "https://i.ibb.co/BVbmSvW2/men2.jpg",
        price: 28999,
        description: "Swiss lace wig with undetectable hairline. 100% natural look."
      }
    ]
  },
  {
    id: 2,
    title: "Lady Hair Extensions",
    routeName: "lady-hair",
    items: [
      {
        id: 10,
        name: "Premium Straight Hair Extensions",
        imageUrl: "https://i.ibb.co/N68FR6kw/lady1.jpg",
        price: 89999,
        description: "100% human hair, silky smooth and tangle-free."
      },
      {
        id: 11,
        name: "Natural Wavy Hair Extensions in Pakistan",
        imageUrl: "https://i.ibb.co/2YkjTSJV/lady2.jpg",
        price: 52999,
        description: "Beautiful natural waves for a perfect everyday look."
      },
      {
        id: 12,
        name: "Bouncy Curly Hair Extensions In Pakistan",
        imageUrl: "https://i.ibb.co/zT3Lk3NV/lady3.jpg",
        price: 75999,
        description: "Premium curly hair with excellent bounce and texture."
      },
      {
        id: 13,
        name: "Long Black Lace Front Wig",
        imageUrl: "https://i.ibb.co/yBcYxm73/lady4.jpg",
        price: 74999,
        description: "Lace front wig with long, flowing black hair."
      },
      {
        id: 14,
        name: "Ombre Brown Full Lace Wig",
        imageUrl: "https://i.ibb.co/gZwFD7zK/lady5.jpg",
        price: 39999,
        description: "Full lace wig with a beautiful ombre brown color."
      },
      {
        id: 15,
        name: "Blonde Human Hair Extensions",
        imageUrl: "https://i.ibb.co/2fJ3CT5/lady6.jpg",
        price: 79999,
        description: "Premium blonde extensions made from 100% virgin hair."
      },
      {
        id: 16,
        name: "Luxury Remy Hair Extensions",
        imageUrl: "https://i.ibb.co/YBnJX7df/lady7.jpg",
        price: 70000,
        description: "High-quality Remy hair extensions for a natural look."
      }
    ]
  },
  {
    id: 3,
    title: "Hair Units",
    routeName: "hair-units",
    items: [
      {
        id: 17,
        name: "USA Hair Unit-Premium",
        imageUrl: "https://i.ibb.co/Gzr645g/Whats-App-Image-2026-07-16-at-6-05-30-AM.jpg",
        price: 16500,
        description: "Premium quality USA hair unit. Natural look and feel."
      },
      {
        id: 18,
        name: "Mono Hair Unit A plus",
        imageUrl: "https://i.ibb.co/FLRcsQVK/Whats-App-Image-2026-07-16-at-11-09-39-AM.jpg",
        price: 16500,
        description: "With undetectable appearance."
      },
      {
        id: 19,
        name: "Swiss lass",
        imageUrl: "https://i.ibb.co/YTLzRPQy/Whats-App-Image-2026-07-16-at-11-18-26-AM.jpg",
        price: 28000,
        description: "Mirage hair unit - lightweight and breathable design."
      },
      {
        id: 20,
        name: "USA Advanced Technology",
        imageUrl: "https://i.ibb.co/4gfLhzcG/Whats-App-Image-2026-07-16-at-11-20-15-AM.jpg",
        price: 16000,
        description: "Advanced technology hair unit for complete coverage and natural look."
      }
    ]
  }
];

export default SHOP_DATA;